export default "__VITE_ASSET__BsyArImO__"